//后台管理系统的整体布局框架
<template>
    <div>
        <el-container style="height: 100vh">

            <el-header style="padding: 0;">
                <div class="bg-header">
                    <div class="flex align-center">
                        <img :src="require('@/assets/logo.png')" style="width: 50px; height: 50px;">
                        <span style="margin-left:10px">非遗文化管理端</span>
                    </div>
                    <div style="display: flex;align-items: center">
                        <el-avatar :size="60" :src="UserInfo.ImageUrls" size="medium">
                            <img :src="require('@/assets/默认头像.png')" />
                        </el-avatar>
                        <div style="margin-left:10px">
                            <el-dropdown>
                                <span class="el-dropdown-link" style="color:white">
                                    {{ UserInfo.Name }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div @click="ToPath('/Admin/UserPerson')">个人信息</div>

                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div @click="ToPath('/Admin/PasswordEdit')">修改密码</div>

                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div @click="LoginOut()">退出</div>
                                    </el-dropdown-item>

                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>

                    </div>
                </div>


            </el-header>


            <el-container>
                <!-- 左侧菜单 -->
                <div class="custom-menu">
                    <!-- 控制台 -->
                    <div class="menu-group">
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/SynthesizeAnalyse' }"
                            @click="ToPath('/Admin/SynthesizeAnalyse')">
                            <i class="el-icon-monitor"></i>
                            <span>非遗综合分析</span>
                        </div>
                    </div>

                    <!-- 用户与店铺管理 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-user"></i>
                            <span>用户与店铺</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/UserList' }"
                            @click="ToPath('/Admin/UserList')">
                            <i class="el-icon-user-solid"></i>
                            <span>用户信息</span>
                        </div>
                           <div class="menu-item" :class="{ active: $route.path === '/Admin/WeChat' }"
                            @click="ToPath('/Admin/WeChat')">
                            <i class="el-icon-s-shop"></i>
                            <span>用户咨询</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/ShopEdit' }"
                            @click="ToPath('/Admin/ShopEdit')">
                            <i class="el-icon-s-shop"></i>
                            <span>店铺信息</span>
                        </div>
                    </div>

                    <!-- 文创品管理 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-goods"></i>
                            <span>文创品管理</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/GoodTypeList' }"
                            @click="ToPath('/Admin/GoodTypeList')">
                            <i class="el-icon-collection"></i>
                            <span>文创品分类</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/GoodList' }"
                            @click="ToPath('/Admin/GoodList')">
                            <i class="el-icon-shopping-bag-1"></i>
                            <span>文创品维护</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/GoodStockList' }"
                            @click="ToPath('/Admin/GoodStockList')">
                            <i class="el-icon-box"></i>
                            <span>库存记录</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/GoodReplenishmentList' }"
                            @click="ToPath('/Admin/GoodReplenishmentList')">
                            <i class="el-icon-warning-outline"></i>
                            <span>库存预警</span>
                        </div>
                    </div>
                 

                    <!-- 订单管理 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-document"></i>
                            <span>订单管理</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/OrderInfoList' }"
                            @click="ToPath('/Admin/OrderInfoList')">
                            <i class="el-icon-tickets"></i>
                            <span>商家订单</span>
                        </div>
                    </div>
                    <!--非遗活动-->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-document"></i>
                            <span>非遗活动</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/ActivityList' }"
                            @click="ToPath('/Admin/ActivityList')">
                            <i class="el-icon-s-shop"></i>
                            <span>非遗活动</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/ActivityRecordList' }"
                            @click="ToPath('/Admin/ActivityRecordList')">
                            <i class="el-icon-document"></i>
                            <span>非遗活动记录</span>
                        </div>


                    </div>
                    <!-- 话题管理 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-chat-dot-square"></i>
                            <span>话题管理</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/TopicTypeList' }"
                            @click="ToPath('/Admin/TopicTypeList')">
                            <i class="el-icon-collection-tag"></i>
                            <span>话题类型</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/TopicList' }"
                            @click="ToPath('/Admin/TopicList')">
                            <i class="el-icon-chat-line-square"></i>
                            <span>话题信息</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/TopicAnalyseEchart' }"
                            @click="ToPath('/Admin/TopicAnalyseEchart')">
                            <i class="el-icon-data-line"></i>
                            <span>话题统计</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/TopicSynthesizeAnalyse' }"
                            @click="ToPath('/Admin/TopicSynthesizeAnalyse')">
                            <i class="el-icon-data-analysis"></i>
                            <span>话题综合分析</span>
                        </div>
                    </div>

                    <!-- 非遗课程-->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-document"></i>
                            <span>非遗课程</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/CouseTypeList' }"
                            @click="ToPath('/Admin/CouseTypeList')">
                            <i class="el-icon-folder"></i>
                            <span>课程分类</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/CouseList' }"
                            @click="ToPath('/Admin/CouseList')">
                            <i class="el-icon-document"></i>
                            <span>课程列表</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/CouseOrderList' }"
                            @click="ToPath('/Admin/CouseOrderList')">
                            <i class="el-icon-document"></i>
                            <span>课程订单</span>
                        </div>
                    </div>
                    <!-- 非遗文化管理 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-collection"></i>
                            <span>非遗文化管理</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/CulturalTypeList' }"
                            @click="ToPath('/Admin/CulturalTypeList')">
                            <i class="el-icon-folder"></i>
                            <span>非遗文化类别</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/CulturalList' }"
                            @click="ToPath('/Admin/CulturalList')">
                            <i class="el-icon-reading"></i>
                            <span>非遗文化</span>
                        </div>

                        <div class="menu-item" :class="{ active: $route.path === '/Admin/InheritorList' }"
                            @click="ToPath('/Admin/InheritorList')">
                            <i class="el-icon-user"></i>
                            <span>传人</span>
                        </div>
                    </div>

                    <!-- 视频展览 -->
                    <div class="menu-group">
                        <div class="menu-title">
                            <i class="el-icon-video-camera"></i>
                            <span>视频展览</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/VideoExhibitionTypeList' }"
                            @click="ToPath('/Admin/VideoExhibitionTypeList')">
                            <i class="el-icon-folder-opened"></i>
                            <span>视频展览类型</span>
                        </div>
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/VideoExhibitionList' }"
                            @click="ToPath('/Admin/VideoExhibitionList')">
                            <i class="el-icon-video-play"></i>
                            <span>视频展览</span>
                        </div>


                    </div>

                    <!-- 系统通知 -->
                    <div class="menu-group">
                        <div class="menu-item" :class="{ active: $route.path === '/Admin/SysNoticeList' }"
                            @click="ToPath('/Admin/SysNoticeList')">
                            <i class="el-icon-bell"></i>
                            <span>系统通知</span>
                        </div>
                    </div>
                </div>

                <el-main class="admin-main">
                    <el-breadcrumb separator-class="el-icon-arrow-right" class="margin-bottom-xs">
                        <el-breadcrumb-item v-for="(item, index) in breadList" :key="index" :to="item.path">{{
                            item.meta.title
                        }}</el-breadcrumb-item>
                    </el-breadcrumb>

                    <transition>
                        <router-view></router-view>
                    </transition>

                </el-main>

            </el-container>
        </el-container>
    </div>
</template>

<script>

import { adminRouters } from "@/router/index";
import { mapGetters } from "vuex";
export default {
    name: 'Layout',
    data() {
        return {
            routerMenu: [],
            breadList: [],
        }
    },
    computed: {
        ...mapGetters([
            'Token', 'UserInfo', 'RoleType', 'RoleTypeFormat', 'HasUserInfo', 'ColumnType', "UserId"
        ])
    },
    watch: {
        $route() {
            this.getBreadcrumb();
        },
    },

    created() {
        this.routerMenu = adminRouters;
        this.getBreadcrumb();
    },
    methods: {
        //跳转
        async ToPath(url) {
            this.$router.push({
                path: url
            })
        },
        async LoginOut() {

            await this.$store.dispatch('Logout')
            window.location.reload('/Login')
        },
        isHome(route) {
            return route.path === "/Admin";
        },
        getBreadcrumb() {
            let matched = this.$route.matched;
            if (!this.isHome(matched[0])) {
                matched = [{ path: "/Admin", meta: { title: "控制台" } }].concat(matched);
            }
            this.breadList = matched;

        }
    }
}
</script>

<style scoped>
/* 左侧菜单样式 */
.custom-menu {
    width: 220px;
    height: calc(100vh - 60px);
    background: #ffffff;
    border-right: 1px solid #f0e6e6;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 0;
    box-shadow: 1px 0 4px rgba(150, 41, 42, 0.05);
}

/* 菜单组样式 */
.menu-group {
    padding: 8px 0;
    border-bottom: 1px solid #f5e9e9;
    transition: all 0.3s ease;
}

.menu-group:hover {
    background: #fff8f8;
    transform: translateX(5px);
}

/* 菜单组标题 */
.menu-title {
    padding: 10px 15px;
    color: #96292A;
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
}

.menu-title i {
    margin-right: 8px;
    font-size: 18px;
    color: #96292A;
}

/* 菜单项样式 */
.menu-item {
    padding: 12px 15px 12px 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
    color: #96292A;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.menu-item:hover {
    background: #faf0f0;
    color: #96292A;
    padding-left: 35px;
    transform: translateX(5px);
}

.menu-item:hover i {
    color: #96292A;
    transform: scale(1.2);
}

.menu-item.active {
    background: #faf0f0;
    color: #96292A;
    font-weight: 600;
    position: relative;
}

.menu-item.active::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: linear-gradient(to bottom, #96292A, #96292A);
    transform: scaleY(1);
    transition: transform 0.3s ease;
}

.menu-item.active::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 4px;
    background: linear-gradient(to bottom, #96292A, #96292A);
}

.menu-item i {
    margin-right: 10px;
    font-size: 18px;
    color: #96292A;
    transition: all 0.3s ease;
}

.menu-item.active i {
    color: #96292A;
}

/* 滚动条样式 */
.custom-menu::-webkit-scrollbar {
    width: 6px;
}

.custom-menu::-webkit-scrollbar-thumb {
    background: #96292A;
    border-radius: 4px;
    transition: all 0.3s ease;
}

.custom-menu::-webkit-scrollbar-thumb:hover {
    background: rgba(150, 41, 42, 0.8);
}

.custom-menu::-webkit-scrollbar-track {
    background: #fff5f5;
    border-radius: 4px;
}

/* 保持原有样式 */
.admin-main {
    height: calc(100vh - 60px) !important;
    width: calc(100% - 220px) !important;
    background: #fefafa;
}

/* 动画效果 */
@keyframes slideIn {
    from {
        transform: translateX(-100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.menu-group {
    animation: slideIn 0.3s ease-out forwards;
}

/* 菜单组延迟动画 */
.menu-group:nth-child(1) {
    animation-delay: 0.1s;
}

.menu-group:nth-child(2) {
    animation-delay: 0.2s;
}

.menu-group:nth-child(3) {
    animation-delay: 0.3s;
}

.menu-group:nth-child(4) {
    animation-delay: 0.4s;
}

.menu-group:nth-child(5) {
    animation-delay: 0.5s;
}

.menu-group:nth-child(6) {
    animation-delay: 0.6s;
}

.menu-group:nth-child(7) {
    animation-delay: 0.7s;
}

.menu-group:nth-child(8) {
    animation-delay: 0.8s;
}
</style>